module.exports = "https://s91588.cdn.ngenix.net/creditselection-frontend/_next/static/images/imgDesktop-d0f33271c06937aa1187f09500e5c963.png";